import { render } from "./EditSensor.vue?vue&type=template&id=47a0ad52"
import script from "./EditSensor.vue?vue&type=script&lang=js"
export * from "./EditSensor.vue?vue&type=script&lang=js"

import "./EditSensor.vue?vue&type=style&index=0&id=47a0ad52&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render

export default script